module.exports = __webpack_public_path__ + "static/media/signup-img-blue.230fc4cf.png";